import React from 'react';
import orcid from './orcid.svg';

const IconOrcid = () => (
  <div>
    <img src={orcid} alt="orcid" />
  </div>
);

export default IconOrcid;
